import { render, staticRenderFns } from "./PlainFormLayout.vue?vue&type=template&id=7145c079"
import script from "./PlainFormLayout.vue?vue&type=script&lang=js"
export * from "./PlainFormLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports